import * as React from 'react';
import { Link } from '@grandvisionhq/common';

const ProductBlockDetails = ({ children , href , tabIndex , onClick  })=>{
    return /*#__PURE__*/ React.createElement(Link, {
        href: href,
        onClick: onClick,
        className: "v2-product-block-details",
        tabIndex: tabIndex
    }, children);
};

export { ProductBlockDetails };
//# sourceMappingURL=ProductBlockDetails.js.map
